import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component, createRef } from '@wordpress/element';
import PropTypes from 'prop-types';

var ScrollTo =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollTo, _Component);

  function ScrollTo(props) {
    var _this;

    _classCallCheck(this, ScrollTo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollTo).call(this, props));
    _this.scrollTo = _this.scrollTo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollTo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.scrollTo, 250);
    }
  }, {
    key: "scrollTo",
    value: function scrollTo() {
      var offset = this.props.offset;

      if (this.ref.current && this.ref.current.offsetTop) {
        window.scrollTo(0, this.ref.current.offsetTop + parseInt(offset));
      } else {
        setTimeout(this.scrollTo, 250);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      this.ref = createRef();
      return createElement("span", {
        ref: this.ref
      }, children);
    }
  }]);

  return ScrollTo;
}(Component);

ScrollTo.propTypes = {
  /**
   * The offset from the top of the component.
   */
  offset: PropTypes.string
};
ScrollTo.defaultProps = {
  offset: '0'
};
export default ScrollTo;
//# sourceMappingURL=index.js.map